import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyleViewAddressBox = styled.div`
    padding: 16px;
    margin-bottom: 40px;
    background-color: var(--color-grey-500);
    border-radius: var(--radius-10);

    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(2, 1fr);
    @media ${breakpoints.xs} {
        grid-template-columns: repeat(1, 1fr);
    }

    align-items: flex-start;

    div {
        display: flex;
        align-items: center;

        span {
            font-size: var(--size-16);
        }

        span:first-child {
            min-width: 170px;
            margin-right: 10px;
            line-height: 20px;
            color: var(--color-grey-800);
            @media ${breakpoints.xs} {
                font-size: var(--size-12);
                line-height: 18px;
            }
        }
        span:last-child {
            font-weight: bold;
            line-height: 24px;
            color: var(--color-grey-900);
            @media ${breakpoints.xs} {
                font-size: var(--size-14);
                line-height: 21px;
            }
        }
    }
`;
